<template>
  <div id="currency">
    <div class="update-box">
      <div class="material-info">
        <div class="material-details">
          <div v-for="(item, index) in imgList" :key="index" class="img-list">
            <div class="img-box">
              <el-image :src="item.url"></el-image>
              <el-image-viewer
                v-if="showViewer == index"
                :on-close="
                  () => {
                    showViewer = -1;
                  }
                "
                :url-list="[item.url]"
              />
              <div class="img-info">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.fileName"
                  placement="top"
                >
                  <div class="img-name">
                    {{ item.fileName | valLength(15) }}
                  </div>
                </el-tooltip>
                <div class="img-size">
                  文件大小：{{ item.length | changeSize }}
                </div>
                <div class="img-btn">
                  <!-- <div class="btn">重新上传</div> -->
                  <div class="btn" @click="showViewer = index">预览</div>
                  <div class="btn" @click="downLoadFile(item.fileName)">
                    下载
                  </div>
                  <div class="btn" @click="deltetOpen(item)">删除</div>
                </div>
              </div>
            </div>
          </div>
          <div class="img-list">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              drag
              list-type="picture-card"
              :show-file-list="false"
              :multiple="false"
              :before-upload="beforeAvatarUpload"
              :http-request="uplaodMaterialsInfo"
              :disabled="isDisabled"
              @click.native="showDisable"
            >
              <div class="upload-tips"><span>点击上传</span>/拖拽到此区域</div>
            </el-upload>
          </div>
        </div>
        <div class="file-list" v-if="fileList.length > 0">
          <div class="file-info" v-for="(item, index) in fileList" :key="index">
            【资料文件】
            <span>{{ item.fileName | valLength(15) }}</span>
            <span>{{ item.length | changeSize }}</span>
            <span>
              <span class="btn" @click="downLoadFile(item.fileName)">下载</span>
              <span class="btn" @click="deltetOpen(item)">删除</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMaterials,
  uploadMaterials,
  deleteMaterials,
  downloadMaterials
} from "@/http/api/company.js";

export default {
  name: "Index",
  components: {
    "el-image-viewer": () =>
      import("@aiwins/admin-ui/packages/image/src/image-viewer"),
  },
  props: {
    isLoadingImg: Boolean,
  },
  data() {
    return {
      headerText: this.$route.query.type,
      id: this.$route.params.id,
      fileList: [],
      imgList: [],
      showViewer: -1,
      loadingImg: true,
      permissions: this.$store.getters.permissions,
      isDisabled: true,
    };
  },
  watch: {
    isLoadingImg(val) {
      this.loadingImg = this.isLoadingImg;
    },
  },
  mounted() {
    this.getMaterialList();
    this.isDisabled = !this.permissions["Company.UploadMaterials"];
  },
  methods: {
    showDisable() {
      if (this.isDisabled) {
        this.$message.warning({
          message: `您暂无电子档案上传权限`,
          showClose: true,
        });
      }
    },
    downLoadFile(fileName) {
      if (this.permissions["Company.DownloadMaterials"]) {
        downloadMaterials(this.id, {
          fileName
        }).then((res) => {
          const content = res;
          const blob = new Blob([content]);
          if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName)
          }
        });
      } else {
        this.$message.warning({
          message: `您暂无电子档案下载权限`,
          showClose: true,
        });
      }
    },
    deltetOpen(file) {
      if (!this.permissions['Company.ManageEventRecords']) {
        this.$message.warning({
          message: `您暂无电子档案管理权限`,
          showClose: true,
        });
        return;
      }
      this.$confirm(`你确定要删除吗?`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deltetMaterial(file);
        })
        .catch(() => {
        });
    },
    deltetMaterial(val) {
      let data = {
        Type: this.headerText,
        MaterialIds: val.id
      };
      deleteMaterials(this.id, data).then((res) => {
        if (res) {
          this.$message({
            message: "资料删除成功！",
            type: "success",
          });
        }
        this.getMaterialList();
      });
    },
    getMaterialList() {
      this.imgList = [];
      this.fileList = [];
      getMaterials(this.id, { types: this.headerText }).then((res) => {
        for (var i = 0; i < res.result.items.length; i++) {
          if (res.result.items[i].contentType.indexOf("image") != -1) {
            this.imgList.push(res.result.items[i]);
          } else {
            this.fileList.push(res.result.items[i]);
          }
        }
        this.loadingImg = false;
        setTimeout(() => {
          this.$emit("isLoading", this.loadingImg);
        }, 500);
      });
    },
    uplaodMaterialsInfo(req) {
      if (!this.permissions['Company.ManageEventRecords']) {
        this.$message.warning({
          message: `您暂无电子档案管理权限`,
          showClose: true,
        });
        return;
      }
      const file = req.file;
      var formData = new FormData();
      formData.append("Type", this.headerText);
      formData.append("Files", file);
      formData.append("EnableClearUpTheMaterialsForThisType", false);
      uploadMaterials(this.id, formData).then((res) => {
        if (res) {
          this.$message({
            message: "分销商信息更新成功！",
            type: "success",
          });
        }
        this.getMaterialList();
      });
    },
    beforeAvatarUpload(file) {
      const isPIC = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (isPIC && !isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#currency {
  .update-box {
    @include flex(row, center);
    flex-wrap: wrap;
    .material-info {
      margin-bottom: 20px;
      .card-tit {
        margin-bottom: 20px;
        font-size: 12px;
        color: #666666;
      }
      .material-details {
        @include flex(row, center);
        flex-wrap: wrap;
        justify-content: flex-start;
        .img-list {
          margin-bottom: 30px;
          @include flex(row, center);
          justify-content: flex-start;
          width: 390px;
          .img-box {
            @include flex(row, flex-end);
            border: 1px solid #dfdfdf;
            padding: 10px;
            .el-image {
              width: 200px;
              height: 148px;
              text-align: center;
              display: flex;
            align-items: center;
              ::v-deep .el-image__inner {
                width: 200px;
                height: auto;
              }
            }
            ::v-deep .el-image-viewer__close {
              color: #fff;
            }
            .img-info {
              margin-left: 10px;
              margin-bottom: 20px;
              .img-name {
                margin-bottom: 10px;
              }
              .img-btn {
                @include flex(row, center);
                margin-top: 10px;
                width: 130px;
                height: 12px;
                line-height: 12px;
                .btn {
                  margin-right: 10px;
                  cursor: pointer;
                  font-size: 12px;
                  color: $--color-primary;
                }
                .upload-file {
                  display: none;
                }
              }
            }
          }
          .upload-tips {
            color: #bbb;
            span {
              font-size: 14px;
              color: $--color-primary;
            }
          }
        }
        // margin-bottom: 12px;
        ::v-deep .el-upload-dragger {
          border: 0;
        }
        ::v-deep .img-list .el-upload {
          border-radius: 0px;
          width: 350px;
          height: 170px;
          line-height: 190px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        ::v-deep .el-upload--picture-card {
          margin-right: 40px;
          width: 350px;
          height: 150px;
          border-radius: 0;
          border-color: #ddd;
        }
        .img-list .el-upload:hover {
          border-color: #409eff;
        }

        .avatar {
          @include flex(row, center);
          width: 178px;
          height: 400px;
          img {
            width: 50%;
            height: 100%;
          }
          .img-info {
            width: 100%;
            height: 100%;
          }
        }
      }
      .file-list {
        margin-top: 15px;
        padding: 20px;
        min-width: 300px;
        border: 1px dashed #dfdfdf;
        .file-info {
          margin-left: 20px;
          margin-bottom: 15px;
          span {
            margin: 0 5px;
          }
          .btn {
            cursor: pointer;
            color: $--color-primary;
          }
        }
        .file-info:last-child {
          margin-bottom: 0;
        }
      }

      .tips {
        margin-top: 12px;
        font-size: 12px;
        color: #888;
      }
    }
  }
}
</style>
